/**
 * displays the page where users edit the employer profile page
 */
import React from 'react';
import PropTypes from 'prop-types';
import DescriptionView from './DescriptionView';
import DescriptionForm from './DescriptionForm';
import withEditableWrapper from '../../../components/form/EditableWrapper';

const Wrapper = withEditableWrapper(DescriptionForm, DescriptionView);

export default class EditableDescription extends React.Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        id: PropTypes.number.isRequired,
        header: PropTypes.string.isRequired,
        help: PropTypes.string,
        text: PropTypes.string,
        onUpdate: PropTypes.func.isRequired,
        companyName: PropTypes.string,
    };

    render() {
        return <Wrapper {...this.props} />;
    }
}
